import TR from 'utils/TR';
import Segment from 'components/common/Segment';
import T from 'utils/T';
import ex from 'utils/ex';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';
import React from 'react';

export default function TIRBox(props) {
  const {
    data,
    ...rest
  } = props || {};

  const {
    tar_high = 0,
    tar = 0,
    tir = 0,
    tbr = 0,
    tbr_low = 0,
  } = data || {};

  const sum = tar_high + tar + tir + tbr + tbr_low;

  const [b1, b2, b3, b4, b5] = React.useMemo(() => {
    let t1 = tar_high / sum * 100;
    let t2 = tar / sum * 100;
    let t3 = tir / sum * 100;
    let t4 = tbr / sum * 100;
    let t5 = tbr_low / sum * 100;
    let delta = 0;

    const b1 = Math.max(7, t1);
    delta += b1 - t1;
    const b2 = Math.max(7, t2);
    delta += b2 - t2;
    const b4 = Math.max(7, t4);
    delta += b4 - t4;
    const b5 = Math.max(7, t5);
    delta += b5 - t5;
    const b3 = t3 - delta;

    return [b1, b2, b3, b4, b5];
  }, [sum, tar, tar_high, tbr, tbr_low, tir]);
  return (
    <Segment {...ex(['OverviewSummaryBox', 'TIRBox', 'dangerous'], rest)}>
      <svg width={83} height={239} viewBox="0 0 83 239" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M48.9582 4C48.9582 4.73638 49.5551 5.33333 50.2915 5.33333C51.0279 5.33333 51.6248 4.73638 51.6248 4C51.6248 3.26362 51.0279 2.66667 50.2915 2.66667C49.5551 2.66667 48.9582 3.26362 48.9582 4ZM50.2915 4.25H50.7915V3.75H50.2915V4.25ZM51.7915 4.25H52.7915V3.75H51.7915V4.25ZM53.7915 4.25H54.7915V3.75H53.7915V4.25ZM55.7915 4.25H56.7915V3.75H55.7915V4.25ZM57.7915 4.25H58.7915V3.75H57.7915V4.25ZM59.7915 4.25H60.7915V3.75H59.7915V4.25ZM61.7915 4.25H62.7915V3.75H61.7915V4.25ZM63.7915 4.25H64.7915V3.75H63.7915V4.25ZM65.7915 4.25H66.7915V3.75H65.7915V4.25ZM67.7915 4.25H68.7915V3.75H67.7915V4.25ZM69.7915 4.25H70.7915V3.75H69.7915V4.25ZM71.7915 4.25H72.2915V3.75H71.7915V4.25ZM72.2915 73.75V73.25H71.7915V73.75H72.2915ZM72.2915 72.25V71.25H71.7915V72.25H72.2915ZM72.2915 70.25V69.25H71.7915V70.25H72.2915ZM72.2915 68.25V67.25H71.7915V68.25H72.2915ZM72.2915 66.25V65.25H71.7915V66.25H72.2915ZM72.2915 64.25V63.25H71.7915V64.25H72.2915ZM72.2915 62.25V61.25H71.7915V62.25H72.2915ZM72.2915 60.25V59.25H71.7915V60.25H72.2915ZM72.2915 58.25V57.25H71.7915V58.25H72.2915ZM72.2915 56.25L72.2915 55.25H71.7915L71.7915 56.25H72.2915ZM72.2915 54.25V53.25H71.7915V54.25H72.2915ZM72.2915 52.25V51.25H71.7915V52.25H72.2915ZM72.2915 50.25V49.25H71.7915V50.25H72.2915ZM72.2915 48.25V47.25H71.7915V48.25H72.2915ZM72.2915 46.25V45.25H71.7915V46.25H72.2915ZM72.2915 44.25V43.25H71.7915V44.25H72.2915ZM72.2915 42.25V41.25H71.7915V42.25H72.2915ZM72.2915 40.25V39.25H71.7915V40.25H72.2915ZM72.2915 38.25V37.25H71.7915V38.25H72.2915ZM72.2915 36.25V35.25H71.7915V36.25H72.2915ZM72.2915 34.25V33.25H71.7915V34.25H72.2915ZM72.2915 32.25V31.25H71.7915V32.25H72.2915ZM72.2915 30.25V29.25H71.7915V30.25H72.2915ZM72.2915 28.25V27.25H71.7915V28.25H72.2915ZM72.2915 26.25V25.25H71.7915V26.25H72.2915ZM72.2915 24.25V23.25H71.7915V24.25H72.2915ZM72.2915 22.25L72.2915 21.25H71.7915L71.7915 22.25H72.2915ZM72.2915 20.25V19.25H71.7915V20.25H72.2915ZM72.2915 18.25V17.25H71.7915V18.25H72.2915ZM72.2915 16.25V15.25H71.7915V16.25H72.2915ZM72.2915 14.25V13.25L71.7915 13.25V14.25H72.2915ZM72.2915 12.25V11.25H71.7915V12.25H72.2915ZM72.2915 10.25V9.25L71.7915 9.25V10.25H72.2915ZM72.2915 8.25V7.25L71.7915 7.25V8.25H72.2915ZM72.2915 6.25V5.25H71.7915V6.25H72.2915ZM72.2915 4.25V3.75L71.7915 3.75V4.25H72.2915Z" fill="#AAAAAA" />
        <path d="M48.9582 233.5C48.9582 232.764 49.5551 232.167 50.2915 232.167C51.0279 232.167 51.6248 232.764 51.6248 233.5C51.6248 234.236 51.0279 234.833 50.2915 234.833C49.5551 234.833 48.9582 234.236 48.9582 233.5ZM50.2915 233.25H50.7915V233.75H50.2915V233.25ZM51.7915 233.25H52.7915V233.75H51.7915V233.25ZM53.7915 233.25H54.7915V233.75H53.7915V233.25ZM55.7915 233.25H56.7915V233.75H55.7915V233.25ZM57.7915 233.25H58.7915V233.75H57.7915V233.25ZM59.7915 233.25H60.7915V233.75H59.7915V233.25ZM61.7915 233.25H62.7915V233.75H61.7915V233.25ZM63.7915 233.25H64.7915V233.75H63.7915V233.25ZM65.7915 233.25H66.7915V233.75H65.7915V233.25ZM67.7915 233.25H68.7915V233.75H67.7915V233.25ZM69.7915 233.25H70.7915V233.75H69.7915V233.25ZM71.7915 233.25H72.2915V233.75H71.7915V233.25ZM72.2915 163.75V164.25H71.7915V163.75H72.2915ZM72.2915 165.25V166.25H71.7915V165.25H72.2915ZM72.2915 167.25V168.25H71.7915V167.25H72.2915ZM72.2915 169.25V170.25H71.7915V169.25H72.2915ZM72.2915 171.25V172.25H71.7915V171.25H72.2915ZM72.2915 173.25V174.25H71.7915V173.25H72.2915ZM72.2915 175.25V176.25H71.7915V175.25H72.2915ZM72.2915 177.25V178.25H71.7915V177.25H72.2915ZM72.2915 179.25V180.25H71.7915V179.25H72.2915ZM72.2915 181.25L72.2915 182.25H71.7915L71.7915 181.25H72.2915ZM72.2915 183.25V184.25H71.7915V183.25H72.2915ZM72.2915 185.25V186.25H71.7915V185.25H72.2915ZM72.2915 187.25V188.25H71.7915V187.25H72.2915ZM72.2915 189.25V190.25H71.7915V189.25H72.2915ZM72.2915 191.25V192.25H71.7915V191.25H72.2915ZM72.2915 193.25V194.25H71.7915V193.25H72.2915ZM72.2915 195.25V196.25H71.7915V195.25H72.2915ZM72.2915 197.25V198.25H71.7915V197.25H72.2915ZM72.2915 199.25V200.25H71.7915V199.25H72.2915ZM72.2915 201.25V202.25H71.7915V201.25H72.2915ZM72.2915 203.25V204.25H71.7915V203.25H72.2915ZM72.2915 205.25V206.25H71.7915V205.25H72.2915ZM72.2915 207.25V208.25H71.7915V207.25H72.2915ZM72.2915 209.25V210.25H71.7915V209.25H72.2915ZM72.2915 211.25V212.25H71.7915V211.25H72.2915ZM72.2915 213.25V214.25H71.7915V213.25H72.2915ZM72.2915 215.25L72.2915 216.25H71.7915L71.7915 215.25H72.2915ZM72.2915 217.25V218.25H71.7915V217.25H72.2915ZM72.2915 219.25V220.25H71.7915V219.25H72.2915ZM72.2915 221.25V222.25H71.7915V221.25H72.2915ZM72.2915 223.25V224.25L71.7915 224.25V223.25H72.2915ZM72.2915 225.25V226.25H71.7915V225.25H72.2915ZM72.2915 227.25V228.25L71.7915 228.25V227.25H72.2915ZM72.2915 229.25V230.25L71.7915 230.25V229.25H72.2915ZM72.2915 231.25V232.25H71.7915V231.25H72.2915ZM72.2915 233.25V233.75L71.7915 233.75V233.25H72.2915Z" fill="#AAAAAA" />
      </svg>
      <div>
        <HBox>
          <VBox full {...ex('TIRLabels')}>
            <svg width={28} height={3} viewBox="0 0 28 3" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ top: `${Math.min(b1 + (b2 / 2), 35)}%` }}>
              <path d="M0.333171 1.5C0.333171 2.23638 0.930124 2.83333 1.6665 2.83333C2.40288 2.83333 2.99984 2.23638 2.99984 1.5C2.99984 0.76362 2.40288 0.166667 1.6665 0.166667C0.930124 0.166667 0.333171 0.76362 0.333171 1.5ZM1.6665 1.75H2.1665V1.25H1.6665V1.75ZM3.1665 1.75H4.1665V1.25H3.1665V1.75ZM5.1665 1.75H6.1665V1.25H5.1665V1.75ZM7.1665 1.75H8.1665V1.25H7.1665V1.75ZM9.1665 1.75H10.1665V1.25H9.1665V1.75ZM11.1665 1.75H12.1665V1.25H11.1665V1.75ZM13.1665 1.75H14.1665V1.25H13.1665V1.75ZM15.1665 1.75H16.1665V1.25H15.1665V1.75ZM17.1665 1.75H18.1665V1.25H17.1665V1.75ZM19.1665 1.75H20.1665V1.25H19.1665V1.75ZM21.1665 1.75H22.1665V1.25H21.1665V1.75ZM23.1665 1.75H24.1665V1.25H23.1665V1.75ZM25.1665 1.75H26.1665V1.25H25.1665V1.75ZM27.1665 1.75H27.6665V1.25H27.1665V1.75Z" fill="#999999" />
            </svg>
            <svg width={28} height={3} viewBox="0 0 28 3" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ top: `${Math.max(b1 + b2 + b3 + (b4 / 2), 65)}%` }}>
              <path d="M0.333171 1.5C0.333171 2.23638 0.930124 2.83333 1.6665 2.83333C2.40288 2.83333 2.99984 2.23638 2.99984 1.5C2.99984 0.76362 2.40288 0.166667 1.6665 0.166667C0.930124 0.166667 0.333171 0.76362 0.333171 1.5ZM1.6665 1.75H2.1665V1.25H1.6665V1.75ZM3.1665 1.75H4.1665V1.25H3.1665V1.75ZM5.1665 1.75H6.1665V1.25H5.1665V1.75ZM7.1665 1.75H8.1665V1.25H7.1665V1.75ZM9.1665 1.75H10.1665V1.25H9.1665V1.75ZM11.1665 1.75H12.1665V1.25H11.1665V1.75ZM13.1665 1.75H14.1665V1.25H13.1665V1.75ZM15.1665 1.75H16.1665V1.25H15.1665V1.75ZM17.1665 1.75H18.1665V1.25H17.1665V1.75ZM19.1665 1.75H20.1665V1.25H19.1665V1.75ZM21.1665 1.75H22.1665V1.25H21.1665V1.75ZM23.1665 1.75H24.1665V1.25H23.1665V1.75ZM25.1665 1.75H26.1665V1.25H25.1665V1.75ZM27.1665 1.75H27.6665V1.25H27.1665V1.75Z" fill="#999999" />
            </svg>

            <VBox {...ex(['TIRLabel', 'TIR'])}>
              <div>
                {T('TIR')}
              </div>
              <HBox>
                <div {...ex('Value')}>
                  {tir}
                </div>
                <div {...ex('Unit')}>
                  {T('%')}
                </div>
              </HBox>
            </VBox>
            <VBox {...ex(['TIRLabel', 'TAR'], { style: { top: `${Math.min(b1 + (b2) / 2, 35)}%` } })}>
              <div>
                {T('TAR')}
              </div>
              <HBox>
                <div {...ex('Value')}>
                  {tar}
                </div>
                <div {...ex('Unit')}>
                  {T('%')}
                </div>
              </HBox>
            </VBox>
            <VBox {...ex(['TIRLabel', 'TBR'], { style: { top: `${Math.max(b1 + b2 + b3 + (b4 / 2), 65)}%` } })}>
              <div>
                {T('TBR')}
              </div>
              <HBox>
                <div {...ex('Value')}>
                  {tbr}
                </div>
                <div {...ex('Unit')}>
                  {T('%')}
                </div>
              </HBox>
            </VBox>
            <VBox {...ex(['TIRLabel', 'VeryHigh'])}>
              <div>
                {T('Very High')}
              </div>
              <HBox>
                <div {...ex('Value')}>
                  {tar_high}
                </div>
                <div {...ex('Unit')}>
                  {T('%')}
                </div>
              </HBox>
            </VBox>
            <VBox {...ex(['TIRLabel', 'VeryLow'])}>
              <div>
                {T('Very Low')}
              </div>
              <HBox>
                <div {...ex('Value')}>
                  {tbr_low}
                </div>
                <div {...ex('Unit')}>
                  {T('%')}
                </div>
              </HBox>
            </VBox>
          </VBox>
          <VBox {...ex('TIRChart')}>
            <div {...{ style: { height: `${b1}%` } }} />
            <div {...{ style: { height: `${b2}%` } }} />
            <div {...{ style: { height: `${b3}%` } }} />
            <div {...{ style: { height: `${b4}%` } }} />
            <div {...{ style: { height: `${b5}%` } }} />
          </VBox>
        </HBox>
      </div>
    </Segment>
  );
}
